<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="基金代码">
              <a-input
                placeholder="请输入基金代码"
                v-model="queryParam.fundCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="基金类型">
              <j-dict-select-tag
                type="list"
                v-model="queryParam.fundType"
                dictCode="fund_type"
                placeholder="请选择基金类型"
              />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="基金状态">
                <j-dict-select-tag
                  type="list"
                  v-model="queryParam.fundStatus"
                  dictCode="fund_status"
                  placeholder="请选择基金状态"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="风险等级">
                <j-dict-select-tag
                  type="list"
                  v-model="queryParam.fundRisk"
                  dictCode="fund_risk"
                  placeholder="请选择风险等级"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="基金名称">
                <a-input
                  placeholder="请输入基金名称"
                  v-model="queryParam.fundShortName"
                ></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 批量修改发布渠道区域 -->
    <a-modal
      title="批量修改发布渠道区域"
      :visible="channelVisible"
      @cancel="HandleCancel"
      @ok="HandleOk"
      width="1000px"
    >
      <a-form-model
        ref="ruleForm1"
        :model="addForm1"
        :rules="addRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="所属渠道" prop="channelCodes">
          <a-select
            mode="multiple"
            style="width: 100%"
            v-model="addForm1.channelCodes"
          >
            <a-select-option v-for="item in channelList" :key="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 批量修改发布渠道区域END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <!--      <a-button @click="batchDel" type="primary" icon="plus">批量删除</a-button>-->
      <!--      <a-button @click="batchDel" type="primary" icon="import">同步直销状态</a-button>-->
      <!--      <a-button @click="batchSetChannel" type="primary" icon="edit">批量修改发布渠道</a-button>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel"
            ><a-icon type="primary" />批量删除</a-menu-item
          >
          <a-menu-item @click="putAway"
            ><a-icon type="primary" />批量上架</a-menu-item
          >
          <a-menu-item @click="soldOut"
            ><a-icon type="primary" />批量下架</a-menu-item
          >
          <a-menu-item @click="exportOrganization"
            ><a-icon type="primary" />批量导出销售机构</a-menu-item
          >
          <!--          <a-menu-item  @click="checkSuccess"><a-icon type="primary"/>审核通过</a-menu-item>-->
          <!--          <a-menu-item  @click="checkFail"><a-icon type="primary"/>审核驳回</a-menu-item>-->
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>

      <a-button @click="exportOrganizationAll" type="primary"
        >导出全部销售机构</a-button
      >
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="fundName" slot-scope="text, scope">
          <a href="javascript:void(0)" @click="fundDetails(scope)">{{
            scope.fundName
          }}</a>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑 </a>
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => handleDelete(record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a @click="handleAudit(record.id)" v-if="record.checked == 3">审核</a>
          <a-divider type="vertical" />
        </span>
      </a-table>
    </div>

    <fundInfo-modal ref="modalForm" @ok="modalFormOk"></fundInfo-modal>
  </a-card>
</template>

<script>
import { getAction, postAction, downloadFile } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import FundInfoModal from './modules/FundInfoModal';
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue';

export default {
  name: 'FundInfoList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JDictSelectTag,
    FundInfoModal
  },
  data() {
    return {
      description: '公募产品管理页面',
      channelVisible: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      addForm1: {},
      channelList: [],
      // 表头
      columns: [
        {
          title: '基金代码',
          align: 'center',
          dataIndex: 'fundCode'
        },
        {
          title: '基金名称',
          align: 'center',
          dataIndex: 'fundName',
          scopedSlots: { customRender: 'fundName' }
        },
        {
          title: '基金类型',
          align: 'center',
          dataIndex: 'fundType_dictText'
        },
        {
          title: '基金状态',
          align: 'center',
          dataIndex: 'fundStatus_dictText'
        },
        {
          title: '风险等级',
          align: 'center',
          dataIndex: 'fundRisk_dictText'
        },
        {
          title: '起投金额',
          align: 'center',
          dataIndex: 'fundMinAmount'
        },
        {
          title: '上架状态',
          align: 'center',
          dataIndex: 'isDelete_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        // list: process.env.VUE_APP_CMS_PRODUCT +"/admin/product/fundInfo/list",
        delete:
          process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/fundInfo/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/exportXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/fundInfo/importExcel',
        soldOut:
          process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/soldOut',
        putAway:
          process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/putAway',
        checkSuccess:
          process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/fundInfo/checkSuccess',
        checkFail:
          process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/checkFail',
        audit: process.env.VUE_APP_CMS_PRODUCT + '/admin/product/fundInfo/audit'
      },
      addRules: {
        channelCodes: [
          { required: true, message: '请选择所属渠道', trigger: 'blur' }
        ]
      },
      dictOptions: {}
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
  methods: {
    //审核时查询临时表中的数据
    handleAudit(id) {
      getAction(this.url.audit, { id: id }).then(res => {
        if (res.success) {
          //向model框中放入临时表的数据
          this.handleEdit(res.result);
        }
      });
    },
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    initDictConfig() {},
    putAway: function() {
      if (!this.url.putAway) {
        this.$message.error('请设置url.putAway属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认批量上架',
          content: '是否批量上架？?',
          onOk: function() {
            that.loading = true;
            getAction(that.url.putAway, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    soldOut: function() {
      if (!this.url.soldOut) {
        this.$message.error('请设置url.soldOut属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认批量下架',
          content: '是否批量下架？?',
          onOk: function() {
            that.loading = true;
            getAction(that.url.soldOut, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    checkSuccess: function() {
      if (!this.url.checkSuccess) {
        this.$message.error('请设置url.checkSuccess属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认审批成功',
          content: '是否批量审批？?',
          onOk: function() {
            that.loading = true;
            getAction(that.url.checkSuccess, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    checkFail: function() {
      if (!this.url.checkFail) {
        this.$message.error('请设置url.checkFail属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认审批失败',
          content: '是否批量审批？?',
          onOk: function() {
            that.loading = true;
            getAction(that.url.checkFail, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },
    HandleCancel(e) {
      this.channelVisible = false;
    },
    HandleOk(e) {
      this.loading = true;
      postAction(
        process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/fundInfo/batchSetChannel',
        {
          productIds: `${this.selectedRowKeys}`,
          channelCodes: `${this.addForm1.channelCodes}`
        }
      )
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
          this.channelVisible = false;
          this.addForm1 = {};
          this.selectedRowKeys = [];
          this.selectionRows = [];
          this.searchQuery();
        });
    },
    batchSetChannel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        this.channelVisible = true;
        getAction(
          process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/queryAll',
          {}
        ).then(res => {
          if (res.success) {
            this.channelList = res.result;
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    exportOrganization() {
      downloadFile(
        process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundOrganization/exportOrganization',
        '销售机构.xls',
        { ids: this.selectedRowKeys.join(',') }
      ).then(res => {});
    },
    exportOrganizationAll() {
      downloadFile(
        process.env.VUE_APP_CMS_PRODUCT +
          '/admin/product/productsFundOrganization/exportOrganizationAll',
        '销售机构.xls',
        { ids: this.selectedRowKeys.join(',') }
      ).then(res => {});
    },
    fundDetails(fund) {
      this.$router.push(
        '/product/ProductsFundDetails/FundDetails?fundCode=' + fund.fundCode
      );
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
